import FormParceiro from '@/components/FormParceiro/FormParceiro.vue';

export default {
    name: "EditarParceiro",
    components: { FormParceiro }
}